(function () {
  'use strict';

  var ROOT_SELECTOR = '#snize_results';
  var CARD_SELECTOR = ROOT_SELECTOR + ' .snize-product';
  var CTA_SELECTOR = '.snize-button, .snize-add-to-cart-container .snize-button, .snize-add-to-cart-container a, .snize-add-to-cart-container button';
  var DISABLED_CLASS = 'snize-stock-disabled';
  var PROCESSED_ATTR = 'data-snize-stock-checked';

  /** @type {Map<string, Promise<boolean>>} */
  var availabilityCache = new Map();
  var observer = null;
  var scanTimer = null;

  function normalizeBool(value) {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value > 0;
    if (typeof value !== 'string') return null;
    var v = value.trim().toLowerCase();
    if (!v) return null;
    if (v === 'true' || v === '1' || v === 'yes') return true;
    if (v === 'false' || v === '0' || v === 'no') return false;
    return null;
  }

  function getCardAvailabilityFromData(card) {
    if (!(card instanceof HTMLElement)) return null;
    var candidates = [
      card.getAttribute('data-available'),
      card.getAttribute('data-availability'),
      card.getAttribute('data-in-stock'),
      card.getAttribute('data-in_stock'),
      card.getAttribute('data-is-available'),
      card.dataset && card.dataset.available,
      card.dataset && card.dataset.inStock,
      card.dataset && card.dataset.in_stock,
    ];
    for (var i = 0; i < candidates.length; i++) {
      var parsed = normalizeBool(candidates[i]);
      if (parsed != null) return parsed;
    }
    return null;
  }

  function getVariantId(card) {
    if (!(card instanceof HTMLElement)) return '';
    return (
      card.getAttribute('data-variant-id') ||
      card.getAttribute('data-product-variant-id') ||
      card.getAttribute('data-default-variant-id') ||
      ''
    ).trim();
  }

  function getProductHandle(card) {
    if (!(card instanceof HTMLElement)) return '';
    var link = card.querySelector('a[href*="/products/"]');
    if (!(link instanceof HTMLAnchorElement)) return '';
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function fetchVariantAvailability(variantId) {
    var key = 'variant:' + variantId;
    if (availabilityCache.has(key)) return availabilityCache.get(key);
    var p = fetch('/variants/' + encodeURIComponent(variantId) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('variant fetch failed');
        return res.json();
      })
      .then(function (variant) {
        return !!(variant && variant.available);
      });
    availabilityCache.set(key, p);
    return p;
  }

  function fetchProductAvailability(handle) {
    var key = 'product:' + handle;
    if (availabilityCache.has(key)) return availabilityCache.get(key);
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed');
        return res.json();
      })
      .then(function (product) {
        return !!(product && product.available);
      });
    availabilityCache.set(key, p);
    return p;
  }

  function resolveAvailability(card) {
    var fromData = getCardAvailabilityFromData(card);
    if (fromData != null) return Promise.resolve(fromData);

    var variantId = getVariantId(card);
    if (variantId) return fetchVariantAvailability(variantId).catch(function () { return null; });

    var handle = getProductHandle(card);
    if (handle) return fetchProductAvailability(handle).catch(function () { return null; });

    return Promise.resolve(null);
  }

  function setDisabledState(cta, text) {
    cta.classList.add(DISABLED_CLASS);
    cta.setAttribute('aria-disabled', 'true');
    cta.setAttribute('data-snize-stock-state', 'out');
    cta.setAttribute(PROCESSED_ATTR, '1');
    cta.textContent = text;

    if (cta instanceof HTMLButtonElement) {
      cta.disabled = true;
      return;
    }
    if (cta instanceof HTMLAnchorElement) {
      cta.setAttribute('tabindex', '-1');
      cta.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
        },
        { capture: true }
      );
    }
  }

  function setInStockState(cta) {
    if (!cta.classList.contains(DISABLED_CLASS)) return;
    cta.classList.remove(DISABLED_CLASS);
    cta.removeAttribute('aria-disabled');
    cta.removeAttribute('data-snize-stock-state');
    if (cta instanceof HTMLButtonElement) cta.disabled = false;
    if (cta instanceof HTMLAnchorElement) cta.removeAttribute('tabindex');
  }

  function getCta(card) {
    if (!(card instanceof HTMLElement)) return null;
    var cta = card.querySelector(CTA_SELECTOR);
    return cta instanceof HTMLElement ? cta : null;
  }

  function applyStockState(card) {
    var cta = getCta(card);
    if (!cta) return;
    if (cta.getAttribute('data-snize-stock-state') === 'locked') return;

    resolveAvailability(card).then(function (available) {
      if (available == null) return;
      if (available) {
        setInStockState(cta);
        cta.setAttribute(PROCESSED_ATTR, '1');
        return;
      }
      setDisabledState(cta, 'Out of stock');
    });
  }

  function scanCards() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var cards = root.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      applyStockState(cards[i]);
    }
  }

  function scheduleScan() {
    if (scanTimer != null) clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scanCards();
    }, 60);
  }

  function bind() {
    scheduleScan();
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    if (observer) observer.disconnect();

    observer = new MutationObserver(function () {
      scheduleScan();
    });
    observer.observe(root, { subtree: true, childList: true, attributes: true });
  }

  function onReady() {
    bind();
    document.addEventListener('Searchanise.Loaded', bind, { once: false });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (!t.closest(ROOT_SELECTOR)) return;
      scheduleScan();
    }, true);
    setInterval(scheduleScan, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();

